import { render } from "./SalesReturn.vue?vue&type=template&id=b043e430&scoped=true"
import script from "./SalesReturn.vue?vue&type=script&lang=js"
export * from "./SalesReturn.vue?vue&type=script&lang=js"

import "./SalesReturn.vue?vue&type=style&index=0&id=b043e430&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b043e430"]])

export default __exports__